import VFFooter from "@vfuk/core-footer";
import type { FooterProps } from "@vfuk/core-footer/dist/Footer.types";

const legalLinks: FooterProps["legalLinks"] = [
  {
    id: "privacy-policy",
    text: "Privacy policy",
    href: "https://www.vodafone.com/business/privacy-policy",
  },
  {
    id: "cookie-policy",
    text: "Cookie policy",
    href: "https://www.vodafone.com/business/privacy-policy#cookie-policy",
  },
  {
    id: "terms-and-conditions",
    text: "Terms & conditions",
    href: "https://www.vodafone.com/business/terms-and-conditions",
  },
];

const socialLinks: FooterProps["social"] = [
  {
    id: "social-linkedin",
    srText: "Linkedin",
    icon: "linkedin",
    href: "https://www.linkedin.com/company/vodafone-business/",
  },
  {
    id: "social-twitter",
    srText: "Twitter",
    icon: "twitter",
    href: "https://twitter.com/vodafonebiz",
  },
  {
    id: "social-youtube",
    srText: "YouTube",
    icon: "youtube",
    href: "https://www.youtube.com/VodafoneBusinessChannel",
  },
];

const copyrightText: FooterProps["copyrightText"] = `© ${new Date().getFullYear()} Vodafone Limited. Registered Office: Vodafone House, The Connection, Newbury, Berkshire, RG14 2FN. Registered in England No 1471587.`;

const Footer = () => (
  <footer>
    <VFFooter
      social={socialLinks}
      legalLinks={legalLinks}
      copyrightText={copyrightText}
    />
  </footer>
);

export default Footer;
